import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    Insert as LAPU_INSERT,
    Select as LAPU_SELECT,
    Delete as LAPU_DELETE,
    Update as LAPU_UPDATE,
    SelectByID as SELECT_BY_ID
} from 'Components/Api/LapuMappingAPI';
import { Select as LAPUPARTY_SELECT } from 'Components/Api/LapuAccountingAPI';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { SelectOperatorPrepaidAndDTH as OPERATOR_SELECT } from 'Components/Api/OperatorsApi';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    Button,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const LapuMapping = () => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [operatorList, setOperatorList] = useState([]);
    const [lapuPartyList, setLapuPartyList] = useState([]);

    const [itemList, setItemList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(false);
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoading(true);

        var response = IsUpdate
            ? await LAPU_UPDATE(requestObj)
            : await LAPU_INSERT(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setSubmitting(true);

        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        resetForm(FormObj);
        resetForm(FormData);
        selectData();
        setTimeout(() => {}, MESSAGE_CLOSE_AFTER);
    };

    const FormValidationSchema = Yup.object({
        LapuNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'lapu no'),
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + ' operator')
            .required(PLEASE_SELECT_VALID + 'operator'),
        LapuPartyMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + ' lapu party')
            .required(PLEASE_SELECT_VALID + 'lapu party')
    });

    const selectData = async () => {
        const { isAuthorized, status, data } = await LAPU_SELECT();

        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);

            return;
        }
        var d = JSON.parse(data);

        setItemList(d);
    };

    const onDeleteClick = async (LapuMasterID) => {
        let jsonObj = {
            LapuMasterID: LapuMasterID
        };
        setLoading(true);
        const response = await LAPU_DELETE(JSON.stringify(jsonObj));
        setLoading(false);

        const { isAuthorized, status, data } = response;
        if (!isAuthorized) LOGOUT();

        setIsError(true);

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            return;
        }
        setSeverity('success');
        setResponseMessage(data);
        setTimeout(() => {
            selectData();
        }, MESSAGE_CLOSE_AFTER);
    };

    const Edit = async (LapuMasterID) => {
        setIsUpdate(true);
        SelectByID(LapuMasterID);
    };

    const SelectByID = async (LapuMasterID) => {
        let jsonObj = {
            LapuMasterID: LapuMasterID
        };

        const response = await SELECT_BY_ID(JSON.stringify(jsonObj));

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);

        setFormObj({
            LapuMasterID: data.LapuMasterID,
            LapuPartyMasterID: data.LapuPartyMasterID,
            OperatorID: data.OperatorID,
            LapuNo: data.LapuNo,
            PartyName: data.PartyName
        });
    };
    var FormData = {
        LapuMasterID: 0,
        LapuPartyMasterID: 0,
        LapuNo: '',
        OperatorID: 0
    };

    const [FormObj, setFormObj] = useState({
        LapuMasterID: 0,
        LapuPartyMasterID: 0,
        LapuNo: '',
        OperatorID: 0
    });

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'LapuMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });
        columns.push({
            label: 'PartyName',
            name: 'PartyName'
        });
        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'LapuNo',
            name: 'LapuNo'
        });

        columns.push({
            label: 'Edit',
            name: 'LapuMasterID',
            edit: true,
            callback: (value) => {
                Edit(value);
            }
        });
        columns.push({
            label: 'Delete',
            name: 'LapuMasterID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });
        setMainColumns(columns);
    };

    const selectLapuParty = async () => {
        const response = await LAPUPARTY_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setLapuPartyList(data);
    };

    const selectOperators = async () => {
        const response = await OPERATOR_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setOperatorList(data);
    };

    useEffect(() => {
        selectLapuParty();
        selectOperators();
        createColumns();
        selectData();
    }, []);

    const LapuPartyItems = lapuPartyList.map(
        ({ LapuPartyMasterID, PartyName }) => (
            <MenuItem key={LapuPartyMasterID} value={LapuPartyMasterID}>
                {PartyName}
            </MenuItem>
        )
    );

    const OperatorItems = operatorList.map(({ OperatorID, OperatorName }) => (
        <MenuItem key={OperatorID} value={OperatorID}>
            {OperatorName}
        </MenuItem>
    ));

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    name="OperatorID"
                                    label="Operator"
                                    title="Operator"
                                >
                                    <MenuItem key="0" value="0">
                                        Operator
                                    </MenuItem>
                                    {OperatorItems}
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialSelect
                                    name="LapuPartyMasterID"
                                    label="LapuParty"
                                    title="LapuParty"
                                >
                                    <MenuItem key="0" value="0">
                                        LapuParty
                                    </MenuItem>
                                    {LapuPartyItems}
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialNumberField
                                    label="LapuNo"
                                    name="LapuNo"
                                    type="text"
                                    length={10}
                                    placeholder="LapuNo"
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title={IsUpdate ? 'Update' : 'Save'}
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                {IsUpdate ? 'Update' : 'Save'}
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            variant="contained"
                            color="secondary"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {UploadForm}
            </Formik>

            <ReactTable data={itemList} columns={mainColumns} />
        </CustomContainer>
    );
};
